// extracted by mini-css-extract-plugin
export default {"crop":"EditIconComponent_crop__kRAUP"};